import React from 'react';
import { Tabs as MuiTabs, Tab as MuiTab, TabsProps as MuiTabsProps, styled } from '@mui/material';
import styles from './Tabs.module.scss';
import { omit } from 'lodash';
import { slugify } from 'new/utils/slugify';

export type TabProps = {
  value: string | number | ReadonlyArray<string>;
  label: string;
};

type TabsProps = {
  tabs: TabProps[];
} & MuiTabsProps;

const StyledTabs = styled(MuiTabs)(() => ({ minHeight: 36 }));

const Tab = styled(MuiTab)(() => ({ fontSize: 12, minHeight: 36 }));

export function Tabs(props: TabsProps) {
  return (
    <StyledTabs {...omit(props, 'tabs')}>
      {props.tabs.map((tab) => (
        <Tab
          key={tab.label}
          className={styles.tab}
          value={tab.value}
          label={tab.label}
          data-testid={slugify(tab.label)}
        />
      ))}
    </StyledTabs>
  );
}
